export const ME_QUERY = /* GraphQL */ `
  query Me {
    me {
      sub
      email
      role
    }
  }
`;

export const INVENTORY_ITEMS_QUERY = /* GraphQL */ `
  query InventoryItems($storeId: ID!) {
    inventoryItems(storeId: $storeId) {
      storeId itemId name unit group supplier sortOrder unitPrice targetEarly targetLate orderNote active updatedAt
    }
  }
`;

export const INVENTORY_CHECK_QUERY = /* GraphQL */ `
  query InventoryCheck($storeId: ID!, $date: AWSDate!) {
    inventoryCheck(storeId: $storeId, date: $date) {
      storeId date status version updatedAt updatedBy confirmedAt
      counts { itemId quantity unitPrice target checkedAt }
      orders { itemId quantity supplier expectedDate status note updatedAt updatedBy }
    }
  }
`;

export const INVENTORY_CHECKS_QUERY = /* GraphQL */ `
  query InventoryChecks($storeId: ID!, $from: AWSDate!, $to: AWSDate!) {
    inventoryChecks(storeId: $storeId, from: $from, to: $to) {
      storeId date status version counted total orderCandidates ordersPending value missingPrices updatedAt
    }
  }
`;

export const INVENTORY_AUDIT_QUERY = /* GraphQL */ `
  query InventoryAudit($storeId: ID!, $date: AWSDate!) {
    inventoryAudit(storeId: $storeId, date: $date) { storeId date action version at by detail }
  }
`;

export const INVENTORY_OPEN_ORDERS_QUERY = /* GraphQL */ `
  query InventoryOpenOrders($storeId: ID!, $from: AWSDate!, $to: AWSDate!) {
    inventoryOpenOrders(storeId: $storeId, from: $from, to: $to) {
      date order { itemId quantity supplier expectedDate status note updatedAt updatedBy }
    }
  }
`;

export const SAVE_INVENTORY_CHECK_MUTATION = /* GraphQL */ `
  mutation SaveInventoryCheck($storeId: ID!, $date: AWSDate!, $expectedVersion: Int!, $status: String!, $counts: [InventoryCountInput!]!) {
    saveInventoryCheck(storeId: $storeId, date: $date, expectedVersion: $expectedVersion, status: $status, counts: $counts) {
      storeId date status version updatedAt updatedBy confirmedAt
      counts { itemId quantity unitPrice target checkedAt }
      orders { itemId quantity supplier expectedDate status note updatedAt updatedBy }
    }
  }
`;

export const SET_INVENTORY_ORDER_MUTATION = /* GraphQL */ `
  mutation SetInventoryOrder($storeId: ID!, $date: AWSDate!, $expectedVersion: Int!, $input: InventoryOrderInput!) {
    setInventoryOrder(storeId: $storeId, date: $date, expectedVersion: $expectedVersion, input: $input) {
      storeId date status version updatedAt updatedBy confirmedAt
      counts { itemId quantity unitPrice target checkedAt }
      orders { itemId quantity supplier expectedDate status note updatedAt updatedBy }
    }
  }
`;

export const UPSERT_INVENTORY_ITEM_MUTATION = /* GraphQL */ `
  mutation UpsertInventoryItem($storeId: ID!, $itemId: ID, $input: InventoryItemInput!) {
    upsertInventoryItem(storeId: $storeId, itemId: $itemId, input: $input) {
      storeId itemId name unit group supplier sortOrder unitPrice targetEarly targetLate orderNote active updatedAt
    }
  }
`;

export const CALENDAR_EVENTS_QUERY = /* GraphQL */ `
  query CalendarEvents($from: AWSDate!, $to: AWSDate!) {
    calendarEvents(from: $from, to: $to) { storeId date title updatedAt }
  }
`;

export const SET_CALENDAR_EVENT_MUTATION = /* GraphQL */ `
  mutation SetCalendarEvent($storeId: ID!, $date: AWSDate!, $title: String!) {
    setCalendarEvent(storeId: $storeId, date: $date, title: $title) { storeId date title updatedAt }
  }
`;

export const DELETE_CALENDAR_EVENT_MUTATION = /* GraphQL */ `
  mutation DeleteCalendarEvent($storeId: ID!, $date: AWSDate!) {
    deleteCalendarEvent(storeId: $storeId, date: $date)
  }
`;

export const STORES_QUERY = /* GraphQL */ `
  query Stores {
    stores {
      id
      name
    }
  }
`;

export const STORES_DETAIL_QUERY = /* GraphQL */ `
  query StoresDetail {
    stores {
      id
      name
      seatCount
      openingHours
      openDate
      airmateAkr
      airregiRegisterIds
      airregiBusinessDayStart
      lunchAggregationEnd
      dinnerAggregationEnd
      lunchStart
      lunchEnd
      dinnerStart
      dinnerEnd
      drinkCategoryKeywords
    }
  }
`;

export const FREEE_DAILY_SALES_QUERY = /* GraphQL */ `
  query FreeeDailySales($storeId: ID!, $from: AWSDate!, $to: AWSDate!) {
    freeeDailySales(storeId: $storeId, from: $from, to: $to) {
      storeId
      date
      companyId
      sectionId
      sectionName
      amount
      dealCount
      details
      paymentTotals
      source
      syncStatus
      syncedAt
    }
  }
`;

export const FREEE_INTEGRATION_STATUS_QUERY = /* GraphQL */ `
  query FreeeIntegrationStatus {
    freeeIntegrationStatus {
      companyId
      connected
      refreshConfigured
      scheduleEnabled
      lastAttemptAt
      lastSuccessAt
      lastTargetDate
      lastStatus
      lastMessage
    }
  }
`;

export const SYNC_FREEE_DAILY_SALES_MUTATION = /* GraphQL */ `
  mutation SyncFreeeDailySales($date: AWSDate!) {
    syncFreeeDailySales(date: $date) {
      targetDate
      status
      message
      records {
        storeId
        amount
        dealCount
      }
    }
  }
`;

export const UPSERT_STORE_MUTATION = /* GraphQL */ `
  mutation UpsertStore(
    $id: ID!
    $name: String!
    $seatCount: Int
    $openingHours: String
    $openDate: AWSDate
    $airmateAkr: String
    $airregiRegisterIds: [String!]
    $airregiBusinessDayStart: String
    $lunchAggregationEnd: String
    $dinnerAggregationEnd: String
    $lunchStart: String
    $lunchEnd: String
    $dinnerStart: String
    $dinnerEnd: String
    $drinkCategoryKeywords: [String!]
  ) {
    upsertStore(
      id: $id
      name: $name
      seatCount: $seatCount
      openingHours: $openingHours
      openDate: $openDate
      airmateAkr: $airmateAkr
      airregiRegisterIds: $airregiRegisterIds
      airregiBusinessDayStart: $airregiBusinessDayStart
      lunchAggregationEnd: $lunchAggregationEnd
      dinnerAggregationEnd: $dinnerAggregationEnd
      lunchStart: $lunchStart
      lunchEnd: $lunchEnd
      dinnerStart: $dinnerStart
      dinnerEnd: $dinnerEnd
      drinkCategoryKeywords: $drinkCategoryKeywords
    ) {
      id
      name
      seatCount
      openingHours
      openDate
      airmateAkr
      airregiRegisterIds
      airregiBusinessDayStart
      lunchAggregationEnd
      dinnerAggregationEnd
      lunchStart
      lunchEnd
      dinnerStart
      dinnerEnd
      drinkCategoryKeywords
    }
  }
`;

export const COST_ENTRIES_QUERY = /* GraphQL */ `
  query CostEntries($storeId: ID!, $from: AWSDate!, $to: AWSDate!) {
    costEntries(storeId: $storeId, from: $from, to: $to) {
      storeId
      date
      costId
      category
      itemName
      costType
      reportInput
      amount
    }
  }
`;

export const STAFF_QUERY = /* GraphQL */ `
  query Staff {
    staff {
      staffKey
      displayName
      lastName
      firstName
      staffCode
      employmentType
      hourlyWage
      monthlySalary
      notes
    }
  }
`;

export const SHIFTS_QUERY = /* GraphQL */ `
  query Shifts($storeId: ID!, $from: AWSDate!, $to: AWSDate!) {
    shifts(storeId: $storeId, from: $from, to: $to) {
      storeId
      date
      staffKey
      displayName
      weekday
      startTime
      endTime
      workMinutes
      actualWorkMinutes
      breakMinutes
    }
  }
`;

export const UPSERT_STAFF_MUTATION = /* GraphQL */ `
  mutation UpsertStaff(
    $staffKey: ID!
    $displayName: String
    $input: StaffInput!
  ) {
    upsertStaff(
      staffKey: $staffKey
      displayName: $displayName
      input: $input
    ) {
      staffKey
      displayName
      employmentType
      hourlyWage
      monthlySalary
      notes
    }
  }
`;

export const DELETE_STAFF_MUTATION = /* GraphQL */ `
  mutation DeleteStaff($staffKey: ID!) {
    deleteStaff(staffKey: $staffKey)
  }
`;

// 最新売上日を特定する軽量プローブクエリ（時間帯別の判定項目のみ取得）
export const LATEST_TXN_DATES_QUERY = /* GraphQL */ `
  query LatestTxnDates($storeId: ID!, $from: AWSDate!, $to: AWSDate!) {
    transactions(storeId: $storeId, from: $from, to: $to) {
      storeId
      visitDate
      visitTime
      accountDate
      accountTime
    }
  }
`;

export const TRANSACTIONS_QUERY = /* GraphQL */ `
  query Transactions($storeId: ID!, $from: AWSDate!, $to: AWSDate!) {
    transactions(storeId: $storeId, from: $from, to: $to) {
      storeId
      txnNo
      visitDate
      visitTime
      accountDate
      accountTime
      total
      customerCount
      itemCount
      stayDurationSec
      receiptName
      resourceName
      staffName
      source
      byPayment {
        method
        amount
      }
      items {
        seq
        category
        menuName
        unitPrice
        quantity
      }
    }
  }
`;

export const OCCUPANCY_TRANSACTIONS_QUERY = /* GraphQL */ `
  query OccupancyTransactions($storeId: ID!, $from: AWSDate!, $to: AWSDate!) {
    transactions(storeId: $storeId, from: $from, to: $to) {
      storeId
      visitDate
      visitTime
      accountDate
      accountTime
      customerCount
      stayDurationSec
    }
  }
`;

export const YEAR_OVER_YEAR_TRANSACTIONS_QUERY = /* GraphQL */ `
  query YearOverYearTransactions($storeId: ID!, $from: AWSDate!, $to: AWSDate!) {
    transactions(storeId: $storeId, from: $from, to: $to) {
      visitDate
      visitTime
      accountDate
      accountTime
      total
      customerCount
      stayDurationSec
      source
      items {
        category
        menuName
        quantity
      }
    }
  }
`;

const PERIOD_FIELDS = `
  storeId
  periodKey
  periodStart
  periodEnd
  sales
  txnCount
  customerCount
  partyCount
  avgSpend
  avgPartySize
  avgItemsPerTxn
  avgStayDurationSec
  lunchSales
  lunchTxnCount
  lunchCustomerCount
  dinnerSales
  dinnerTxnCount
  dinnerCustomerCount
  otherSales
  otherTxnCount
  otherCustomerCount
  foodOrderQuantity
  drinkOrderQuantity
  byPayment {
    method
    amount
  }
  byCategory {
    category
    sales
    quantity
  }
  byReceipt {
    receiptName
    sales
    txnCount
  }
  hourlyDistribution {
    hour
    txnCount
    sales
  }
  topProducts {
    menuName
    quantity
    sales
  }
`;

export const WEEKLY_SUMMARY_QUERY = /* GraphQL */ `
  query WeeklySummary($storeId: ID!, $fromIsoWeek: String!, $toIsoWeek: String!) {
    weeklySummary(
      storeId: $storeId
      fromIsoWeek: $fromIsoWeek
      toIsoWeek: $toIsoWeek
    ) {${PERIOD_FIELDS}}
  }
`;

export const MONTHLY_SUMMARY_QUERY = /* GraphQL */ `
  query MonthlySummary(
    $storeId: ID!
    $fromYearMonth: String!
    $toYearMonth: String!
  ) {
    monthlySummary(
      storeId: $storeId
      fromYearMonth: $fromYearMonth
      toYearMonth: $toYearMonth
    ) {${PERIOD_FIELDS}}
  }
`;

export const DAILY_SALES_QUERY = /* GraphQL */ `
  query DailySales($storeId: ID!, $yearMonth: String!) {
    dailySales(storeId: $storeId, yearMonth: $yearMonth) {
      date
      sales
      customerCount
      txnCount
      lunchSales
      lunchCustomerCount
      lunchTxnCount
      dinnerSales
      dinnerCustomerCount
      dinnerTxnCount
    }
  }
`;

export const SALES_PERIOD_SUMMARIES_QUERY = /* GraphQL */ `
  query SalesPeriodSummaries($storeId: ID!, $fromYearMonth: String!, $toYearMonth: String!) {
    monthlySummary(storeId: $storeId, fromYearMonth: $fromYearMonth, toYearMonth: $toYearMonth) {
      periodKey
      sales
      customerCount
      txnCount
      lunchSales
      lunchCustomerCount
      lunchTxnCount
      dinnerSales
      dinnerCustomerCount
      dinnerTxnCount
    }
  }
`;

export const SALES_TARGET_HISTORY_QUERY = /* GraphQL */ `
  query SalesTargetHistory(
    $storeId: ID!
    $fromYearMonth: String!
    $toYearMonth: String!
  ) {
    monthlySummary(
      storeId: $storeId
      fromYearMonth: $fromYearMonth
      toYearMonth: $toYearMonth
    ) {
      periodKey
      lunchSales
      dinnerSales
    }
  }
`;

export const TARGETS_QUERY = /* GraphQL */ `
  query Targets($storeId: ID!, $fromYearMonth: String!, $toYearMonth: String!) {
    targets(
      storeId: $storeId
      fromYearMonth: $fromYearMonth
      toYearMonth: $toYearMonth
    ) {
      storeId
      yearMonth
      foodCostPct
      laborCostPct
      flPct
      rentPct
      otherPct
      profitPct
      updatedAt
    }
  }
`;

export const SET_TARGET_MUTATION = /* GraphQL */ `
  mutation SetTarget(
    $storeId: ID!
    $yearMonth: String!
    $input: TargetInput!
  ) {
    setTarget(storeId: $storeId, yearMonth: $yearMonth, input: $input) {
      storeId
      yearMonth
      foodCostPct
      laborCostPct
      flPct
      rentPct
      otherPct
      profitPct
      updatedAt
    }
  }
`;

export const REQUEST_CSV_UPLOAD_URL_MUTATION = /* GraphQL */ `
  mutation RequestCsvUploadUrl($fileName: String!, $storeId: ID, $exportedAt: AWSDateTime) {
    requestCsvUploadUrl(fileName: $fileName, storeId: $storeId, exportedAt: $exportedAt) {
      url
      key
      expiresInSec
    }
  }
`;

export const IMPORT_HISTORY_QUERY = /* GraphQL */ `
  query ImportHistory($from: AWSDate!, $to: AWSDate!) {
    importHistory(from: $from, to: $to) {
      importId
      date
      fileName
      csvType
      storeId
      rows
      status
      errors
      createdAt
    }
  }
`;

export const IMPORT_DAY_STATUSES_QUERY = /* GraphQL */ `
  query ImportDayStatuses($from: AWSDate!, $to: AWSDate!) {
    importDayStatuses(from: $from, to: $to) {
      date
      storeId
      source
      rows
      complete
      importedAt
    }
  }
`;

// ----------------------------------------------------------------------------
// 固定費マスタ（店舗別 × 項目別の月額固定値、家賃含む）
// ----------------------------------------------------------------------------
export const FIXED_COST_ITEMS_QUERY = /* GraphQL */ `
  query FixedCostItems($storeId: ID!) {
    fixedCostItems(storeId: $storeId) {
      storeId
      itemKey
      itemName
      amount
      notes
      updatedAt
    }
  }
`;

export const SET_FIXED_COST_ITEM_MUTATION = /* GraphQL */ `
  mutation SetFixedCostItem($storeId: ID!, $input: FixedCostItemInput!) {
    setFixedCostItem(storeId: $storeId, input: $input) {
      storeId
      itemKey
      itemName
      amount
      notes
      updatedAt
    }
  }
`;

export const DELETE_FIXED_COST_ITEM_MUTATION = /* GraphQL */ `
  mutation DeleteFixedCostItem($storeId: ID!, $itemKey: String!) {
    deleteFixedCostItem(storeId: $storeId, itemKey: $itemKey)
  }
`;

// ----------------------------------------------------------------------------
// 人件費マスタ（店舗別 × 項目別の月額固定値、暫定）
// ----------------------------------------------------------------------------
export const LABOR_COST_ITEMS_QUERY = /* GraphQL */ `
  query LaborCostItems($storeId: ID!) {
    laborCostItems(storeId: $storeId) {
      storeId
      itemKey
      itemName
      amount
      notes
      updatedAt
    }
  }
`;

export const SET_LABOR_COST_ITEM_MUTATION = /* GraphQL */ `
  mutation SetLaborCostItem($storeId: ID!, $input: LaborCostItemInput!) {
    setLaborCostItem(storeId: $storeId, input: $input) {
      storeId
      itemKey
      itemName
      amount
      notes
      updatedAt
    }
  }
`;

export const DELETE_LABOR_COST_ITEM_MUTATION = /* GraphQL */ `
  mutation DeleteLaborCostItem($storeId: ID!, $itemKey: String!) {
    deleteLaborCostItem(storeId: $storeId, itemKey: $itemKey)
  }
`;

// ----------------------------------------------------------------------------
// 借入マスタ（全社）
// ----------------------------------------------------------------------------
export const LOANS_QUERY = /* GraphQL */ `
  query Loans {
    loans {
      loanId
      name
      lender
      startDate
      initialAmount
      outstanding
      monthlyPayment
      interestRate
      endDate
      notes
      updatedAt
    }
  }
`;

export const UPSERT_LOAN_MUTATION = /* GraphQL */ `
  mutation UpsertLoan($loanId: ID, $input: LoanInput!) {
    upsertLoan(loanId: $loanId, input: $input) {
      loanId
      name
      lender
      startDate
      initialAmount
      outstanding
      monthlyPayment
      interestRate
      endDate
      notes
      updatedAt
    }
  }
`;

export const DELETE_LOAN_MUTATION = /* GraphQL */ `
  mutation DeleteLoan($loanId: ID!) {
    deleteLoan(loanId: $loanId)
  }
`;

// ----------------------------------------------------------------------------
// ベンチマーク（全社デフォルト構成比目標）
// ----------------------------------------------------------------------------
export const BENCHMARK_QUERY = /* GraphQL */ `
  query Benchmark {
    benchmark {
      foodCostPct
      laborCostPct
      flPct
      rentPct
      otherPct
      profitPct
      updatedAt
    }
  }
`;

export const SET_BENCHMARK_MUTATION = /* GraphQL */ `
  mutation SetBenchmark($input: BenchmarkInput!) {
    setBenchmark(input: $input) {
      foodCostPct
      laborCostPct
      flPct
      rentPct
      otherPct
      profitPct
      updatedAt
    }
  }
`;
const DOCUMENT_FIELDS = `
  id fileName scope sizeBytes uploadedAt completedAt pageCount status
  thumbnailStatus error thumbnailError sha256 duplicateOf
`;

export const CREATE_DOCUMENT_UPLOAD_MUTATION = `
  mutation CreateDocumentUpload($input: DocumentUploadInput!) {
    createDocumentUpload(input: $input) {
      document { ${DOCUMENT_FIELDS} }
      url fieldsJson expiresAt maxBytes maxPages
    }
  }
`;

export const DOCUMENTS_QUERY = `
  query ListDocuments($scope: String, $status: String, $fromDate: AWSDate, $toDate: AWSDate, $cursor: String, $limit: Int) {
    listDocuments(scope: $scope, status: $status, fromDate: $fromDate, toDate: $toDate, cursor: $cursor, limit: $limit) {
      items { ${DOCUMENT_FIELDS} }
      nextCursor
    }
  }
`;

export const DOCUMENT_QUERY = `
  query GetDocument($documentId: ID!) {
    getDocument(documentId: $documentId) { ${DOCUMENT_FIELDS} }
  }
`;

export const DOCUMENT_ACCESS_URL_QUERY = `
  query GetDocumentAccessUrl($documentId: ID!, $kind: String!) {
    getDocumentAccessUrl(documentId: $documentId, kind: $kind) { url expiresAt }
  }
`;

export const RETRY_DOCUMENT_PROCESSING_MUTATION = `
  mutation RetryDocumentProcessing($documentId: ID!) {
    retryDocumentProcessing(documentId: $documentId) { ${DOCUMENT_FIELDS} }
  }
`;
